import {useState} from 'react'
import useMessage from '@hooks/useMessage'
import {useMutate} from 'apollo-hooks'
import gql from 'graphql-tag'

export default function useLoyaltyCode() {
  const [loading, setLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState(null)
  const showMessage = useMessage()
  const mutate = useMutate()

  const submit = async ({code, sessionKey = null}) => {
    try {
      setLoading(true)
      const refetchQueries = ['getCheckout', 'getUserPreferences']
      const {setLoyaltyWallet: isValid} = await mutate({
        mutation: gql`
          mutation setLoyaltyWallet($walletCode: String, $sessionKey: String) {
            setLoyaltyWallet(walletCode: $walletCode, sessionKey: $sessionKey)
          }
        `,
        variables: {walletCode: code, sessionKey},
        refetchQueries
      })

      if (isValid) {
        setErrorMessage(null)
        if (code) {
          showMessage('Monedero agregado')
          return true
        } else {
          showMessage('Monedero removido')
          return true
        }
      }

      if (!isValid && code) {
        setErrorMessage('El monedero que intentas guardar no es válido o no existe')
      }
    } catch (error) {
      setErrorMessage(error.message.replace('GraphQL error: ', ''))
      showMessage(error)
    } finally {
      setLoading(false)
    }
  }

  return {
    submit,
    loading,
    errorMessage,
    isValid: !loading && !errorMessage
  }
}
